import type { PublishVenue } from '../types/publish-venue';

/** Normalizes GET /api/publish-venues (array or `{ publish_venues }`). */
export function normalizePublishVenuesListResponse(res: unknown): PublishVenue[] {
  if (Array.isArray(res)) {
    return res as PublishVenue[];
  }
  if (res && typeof res === 'object' && 'publish_venues' in res) {
    const list = (res as { publish_venues: unknown }).publish_venues;
    return Array.isArray(list) ? (list as PublishVenue[]) : [];
  }
  return [];
}
